module.exports = __webpack_public_path__ + "static/reviews-tab-edit-product-html-f7d04f4763afc163d95a6adf7c1adf4c.png";